import { combineReducers } from "redux";
import crawler from "./crawler";
import urls from "./urls";
import { Seo } from "../../types";

export default combineReducers<Seo>({
  crawler,
  urls,
});
